import { render } from "./BubbleRule2Top.vue?vue&type=template&id=6884d7b8&scoped=true"
import script from "./BubbleRule2Top.vue?vue&type=script&lang=js"
export * from "./BubbleRule2Top.vue?vue&type=script&lang=js"

import "./BubbleRule2Top.vue?vue&type=style&index=0&id=6884d7b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6884d7b8"]])

export default __exports__